import { render, staticRenderFns } from "./integracao.vue?vue&type=template&id=688ec746&"
import script from "./integracao.vue?vue&type=script&lang=js&"
export * from "./integracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports